import script from "./procureDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./procureDetail.vue?vue&type=script&setup=true&lang=js"

import "./procureDetail.vue?vue&type=style&index=0&id=4a8ac584&lang=less"

const __exports__ = script;

export default __exports__